import { ReactNode } from 'react';

import { useAuthenticationInterceptor } from './hooks';

interface ApiAuthenticationInterceptorProps {
  children: ReactNode;
}

export const ApiAuthenticationInterceptor = ({ children }: ApiAuthenticationInterceptorProps) => {
  useAuthenticationInterceptor();

  return <>{children}</>;
};
